import { routes } from '@/config';

export const DS_CONSUMER = 'loggedout.web.jobs.search_results.bottom';

export const CITY = 'city';
export const DISCIPLINE = 'discipline';
export const EMPLOYMENT_TYPE = 'employmentType';
export const ROLE = 'role';
export const COMPANY = 'company';
export const SKILL = 'skill';
export const ANY = 'any';
export const SALARY = 'salary';

export const CITIES_DATA_FIELD = 'cities';
export const DISCIPLINES_DATA_FIELD = 'disciplines';
export const EMPLOYMENT_TYPES_DATA_FIELD = 'employmentTypes';
export const ROLES_DATA_FIELD = 'roles';

export const SERPS_PARAMS = {
  [routes.disciplineCity]: {
    category: DISCIPLINE,
    subcategory: CITY,
  },
  [routes.disciplineRole]: {
    category: DISCIPLINE,
    subcategory: ROLE,
  },
  [routes.employmentTypeCity]: {
    category: EMPLOYMENT_TYPE,
    subcategory: CITY,
  },
  [routes.employmentTypeRole]: {
    category: EMPLOYMENT_TYPE,
    subcategory: ROLE,
  },
  [routes.employmentTypeDiscipline]: {
    category: EMPLOYMENT_TYPE,
    subcategory: DISCIPLINE,
  },
  [routes.roleCity]: {
    category: ROLE,
    subcategory: CITY,
  },
  [routes.skillCity]: {
    category: SKILL,
    subcategory: CITY,
  },
  [routes.employmentType]: {
    category: EMPLOYMENT_TYPE,
  },
  [routes.discipline]: {
    category: DISCIPLINE,
  },
  [routes.city]: {
    category: CITY,
  },
  [routes.role]: {
    category: ROLE,
  },
  [routes.company]: {
    category: COMPANY,
  },
  [routes.skill]: {
    category: SKILL,
  },
  [routes.any]: {
    category: ANY,
  },
} as const;

export const TRANSLATIONS_MAP = {
  [ANY]: {
    title: 'JOB_SEO_TERM_JOBS',
    metaTitle: 'XJM_META_TITLE_TERM_ANY_WITH_DATE',
    metaDescription: 'XJM_META_DESCRIPTION_TERM_ANY_WITH_POSTINGS',
    paramName: 'term',
  },
  [COMPANY]: {
    title: 'JOB_SEO_COMPANY_JOBS',
    metaTitle: 'XJM_META_TITLE_COMPANY',
    metaDescription: 'XJM_META_DESCRIPTION_COMPANY',
    paramName: 'term',
  },
  [SKILL]: {
    title: 'JOB_SEO_COMPANY_JOBS',
    metaTitle: 'XJM_META_TITLE_SKILL',
    metaDescription: 'XJM_META_DESCRIPTION_SKILL',
    paramName: 'term',
  },
  [CITY]: {
    title: 'JOB_SEO_CITY_JOBS',
    metaTitle: 'XJM_META_TITLE_CITY_WITH_DATE',
    metaDescription: 'XJM_META_DESCRIPTION_CITY_WITH_POSTINGS',
    paramName: 'city',
  },
  [DISCIPLINE]: {
    title: 'JOB_SEO_CATEGORY_JOBS',
    metaTitle: 'XJM_META_TITLE_CATEGORY',
    metaDescription: 'XJM_META_DESCRIPTION_CATEGORY',
    paramName: 'category',
  },
  [EMPLOYMENT_TYPE]: {
    title: {
      EMPLOYMENT_TYPE_FULL_TIME: 'JOB_SEO_JOB_TYPE_FULL_TIME_JOBS',
      EMPLOYMENT_TYPE_PART_TIME: 'JOB_SEO_JOB_TYPE_PART_TIME_JOBS',
      EMPLOYMENT_TYPE_INTERN: 'JOB_SEO_JOB_TYPE_INTERN_JOBS',
      EMPLOYMENT_TYPE_CONTRACTOR: 'JOB_SEO_JOB_TYPE_CONTRACTOR_JOBS',
      EMPLOYMENT_TYPE_TEMPORARY: 'JOB_SEO_JOB_TYPE_TEMPORARY_JOBS',
      EMPLOYMENT_TYPE_SEASONAL: 'JOB_SEO_JOB_TYPE_SEASONAL_JOBS',
      EMPLOYMENT_TYPE_VOLUNTARY: 'JOB_SEO_JOB_TYPE_VOLUNTARY_JOBS',
    },
    metaTitle: 'XJM_META_TITLE_JOB_TYPE',
    metaDescription: 'XJM_META_DESCRIPTION_JOB_TYPE',
    paramName: 'job_type',
  },
  [ROLE]: {
    title: 'XJM_SEO_JOB_ROLE',
    metaTitle: 'XJM_META_TITLE_TERM_WITH_DATE',
    metaDescription: 'XJM_META_DESCRIPTION_TERM_WITH_POSTINGS',
    paramName: 'term',
  },
  [`${DISCIPLINE}-${CITY}`]: {
    title: 'XJM_SEARCH_TITLE_CATEGORY_CITY',
    metaTitle: 'XJM_META_TITLE_CATEGORY_CITY',
    metaDescription: 'XJM_META_DESCRIPTION_CATEGORY_CITY',
    paramName: 'category',
    subparamName: 'city',
  },
  [`${DISCIPLINE}-${ROLE}`]: {
    title: 'XJM_SEARCH_TITLE_CATEGORY_TERM',
    metaTitle: 'XJM_META_TITLE_CATEGORY_TERM',
    metaDescription: 'XJM_META_DESCRIPTION_CATEGORY_TERM',
    paramName: 'category',
    subparamName: 'term',
  },
  [`${EMPLOYMENT_TYPE}-${CITY}`]: {
    title: 'XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY',
    metaTitle: 'XJM_META_TITLE_EMPLOYMENT_TYPE_CITY_WITH_DATE',
    metaDescription: 'XJM_META_DESCRIPTION_EMPLOYMENT_TYPE_CITY_WITH_POSTINGS',
    paramName: 'job_type',
    subparamName: 'city',
  },
  [`${EMPLOYMENT_TYPE}-${DISCIPLINE}`]: {
    title: 'XJM_SEARCH_TITLE_JOB_TYPE_CATEGORY',
    metaTitle: 'XJM_META_TITLE_JOB_TYPE_CATEGORY',
    metaDescription: 'XJM_META_DESCRIPTION_JOB_TYPE_CATEGORY',
    paramName: 'job_type',
    subparamName: 'category',
  },
  [`${EMPLOYMENT_TYPE}-${ROLE}`]: {
    title: 'XJM_SEARCH_TITLE_JOB_TYPE_TERM',
    metaTitle: 'XJM_META_TITLE_JOB_TYPE_TERM',
    metaDescription: 'XJM_META_DESCRIPTION_JOB_TYPE_TERM',
    paramName: 'job_type',
    subparamName: 'term',
  },
  [`${ROLE}-${CITY}`]: {
    title: 'XJM_SEARCH_TITLE_TERM_CITY_WITH_DATE',
    metaTitle: 'XJM_META_TITLE_TERM_CITY_WITH_POSTINGS',
    metaDescription: 'XJM_META_DESCRIPTION_TERM_CITY_WITH_POSTINGS',
    paramName: 'term',
    subparamName: 'city',
  },
  [`${SKILL}-${CITY}`]: {
    title: 'XJM_SEARCH_TITLE_SKILL_TYPE_CITY',
    metaTitle: 'XJM_META_TITLE_SKILL_TYPE_CITY',
    metaDescription: 'XJM_META_DESCRIPTION_SKILL_TYPE_CITY',
    paramName: 'term',
    subparamName: 'city',
  },
};
